export default __webpack_public_path__ + "static/media/basem_cv.1047ce48.docx";